<template>
  <div class="link">
    <el-dialog
      title="修改资料链接"
      :visible.sync="dialogVisible"
      width="800px"
      :close-on-click-modal="false"
      class="linkDialog"
      :lock-scroll="false"
      :show-close="false"
      top="15vh"
    >
      <div v-if="showVisible" class="main">
        <div class="qooLink">
          <div class="title">二维码分享</div>
          <div id="qrcode" ref="qrcode" class="qrcode"></div>
          <div class="btnGroup">
            <span @click="copyQrcode">复制二维码</span>
            <span @click="download">下载</span>
          </div>
        </div>
      </div>
      <div v-if="showVisible" class="main mt">
        <div class="shareLink">
          <div class="title">链接分享</div>
          <div class="linkCard">
            <el-input v-model="content" class="inputLinkCss" placeholder="" readonly></el-input>
          </div>
          <div class="btnGroup">
            <el-button
              v-clipboard:copy="this.baseLink + '/application/login'"
              v-clipboard:success="onCopySuccess"
              v-clipboard:error="onCopyError"
              type="primary"
              >复制链接</el-button
            >
            <span class="openLink" @click="onOpenLink">打开链接</span>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">取消</el-button>
        <el-button type="primary" @click="closeDialog">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import QRCode from 'qrcodejs2'
export default {
  data() {
    return {
      dialogVisible: false,
      content: '',
      baseLink:
        process.env.NODE_ENV == 'production'
          ? 'https://exams.i-ronge.com'
          : 'http://139.155.76.29:19098',
      showVisible: false,
    }
  },
  methods: {
    show() {
      this.dialogVisible = true
      this.showVisible = true
      this.buildQRcode()
    },
    buildQRcode() {
      this.$nextTick(() => {
        try {
          new QRCode('qrcode', {
            width: 208,
            height: 190,
            text: this.baseLink + '/application/login',
          })
        } catch (e) {
          console.log(e)
        }
        this.content = this.baseLink + '/application/login'
      })
    },
    async copyQrcode() {
      const img = document.querySelector('#qrcode img')
      const setToClipboard = blob => {
        // eslint-disable-next-line no-undef
        const data = [new ClipboardItem({ [blob.type]: blob })]
        return navigator.clipboard.write(data)
      }
      try {
        const response = await fetch(img.src)
        const blob = await response.blob()
        console.log(blob)
        setToClipboard(blob)
        this.$message.success('复制成功')
      } catch (error) {
        this.$message.success('复制失败')
      }
    },
    download() {
      const src = document.querySelector('#qrcode').children[0].toDataURL('image/png')
      let a = document.createElement('a') // 生成一个a元素
      let event = new MouseEvent('click') // 创建一个单击事件
      a.download = 'QRcode' // 设置图片名称没有设置则为默认
      a.href = src // 将生成的URL设置为a.href属性
      a.dispatchEvent(event) // 触发a的单击事件
    },
    onCopySuccess() {
      this.$message.success('复制成功')
    },
    onCopyError() {
      this.$message.error('复制失败')
    },
    onOpenLink() {
      window.open(this.baseLink + '/application/login')
    },
    closeDialog() {
      this.dialogVisible = false
      this.showVisible = false
    },
  },
}
</script>
<style lang="scss" scoped>
.link {
  .linkDialog {
    .main {
      display: flex;
      justify-content: center;
      .soureCard {
        display: flex;
        .inputCss {
          width: 320px;
        }
        .btnGetLink {
          width: 120px;
          margin-left: 20px;
        }
      }
      .qooLink {
        width: 460px;
        height: 300px;
        background: #e2e2e2;
        .title {
          padding: 10px 20px;
        }
        .qrcode {
          width: 208px;
          height: 190px;
          margin: 10px auto;
        }
        .btnGroup {
          width: 208px;
          margin: 0px auto;
          display: flex;
          justify-content: space-between;
          span {
            display: block;
            cursor: pointer;
            &:first-child {
              border: 1px solid #333;
              padding: 1px;
              color: #333;
            }
            &:last-child {
              background: #169bd5;
              color: #fff;
              padding: 1px 20px;
              border-radius: 4px;
            }
          }
        }
      }
      .shareLink {
        width: 460px;
        height: 160px;
        background: #e2e2e2;
        .title {
          padding: 10px 20px;
        }
        .linkCard {
          padding: 10px 30px;
          ::v-deep .el-input__inner {
            background: #f2f2f2;
          }
        }
        .btnGroup {
          padding: 10px 30px;
          display: flex;
          ::v-deep .el-button {
            width: 98px;
            height: 25px;
          }
          .openLink {
            display: block;
            margin-left: 30px;
            border: 1px solid #1cafee;
            padding: 1px 20px;
            color: #1cafee;
            border-radius: 4px;
            cursor: pointer;
          }
        }
      }
    }
    .mt {
      margin-top: 30px;
    }
  }
}
</style>
